import { gettext } from '@eventbrite/i18n';

import {
    ACCOUNT_SETTINGS_URL,
    BASE_URL,
    CHANGE_PLAN_PATH,
} from '../../constants/main';

export default {
    breadcrumbs: {
        crumbs: [
            {
                path: ACCOUNT_SETTINGS_URL,
                label: gettext('Account Settings'),
            },
            {
                path: `${BASE_URL}${CHANGE_PLAN_PATH}`,
                label: gettext('Change Package'),
            },
        ],
    },
};
